"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = {
            Colors: [
                'default',
                'brown',
                'grey',
                'purple',
                'indigo',
                'blue',
                'cyan',
                'teal',
                'green',
                'lime',
                'pink',
                'red',
                'orange',
                'amber'
            ]
        };
        GState.bind(this, ['theme']);
        fhandler.bind(this, { theme: this.state.theme });
    },
    onInput: function (input) {
        input.reset && fhandler.reset();
        input.selectedFiles && fhandler.set('logo', input.selectedFiles);
    },
    onSelectLogo: function () {
        this.emit('select-file', 'logo');
    },
    onPrev: function () {
        this.emit('prev', this.input.index);
    },
    onNext: function () {
        this.emit('next', this.input.index, this.state.form);
    },
    onSelectColor: async function (color) {
        fhandler.set('theme.color', color);
        await import(`~/views/${ this.state.theme.name }/theme/${ color }/light`);
        await import(`~/views/${ this.state.theme.name }/theme/${ color }/dark`);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Onboarding/components/Customization.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_DefaultLogo = require("~/../public/images/default/institution.png"),
    DefaultLogo = module_DefaultLogo.default || module_DefaultLogo,
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Image_template = require("../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "w-100 p-lg-5 p-2"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "d-flex align-items-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("7aafb4"),
    marko_node0 = marko_createElement("img", {
        src: "/images/icons/paint-palette.png",
        alt: "institution",
        width: "60",
        "class": "mr-4"
      }, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "14", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "font-medium-2 mb-4"
      },
    marko_node5 = marko_createElement("br", null, "26", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("br", null, "27", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("br", null, "28", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "navigation-buttons"
      },
    marko_attrs5 = {
        "class": "btn btn-outline-primary btn-xl text-left d-inline-block"
      },
    marko_attrs6 = {
        "class": "btn btn-primary btn-xl text-left d-inline-block float-right w-50"
      },
    marko_attrs7 = {
        "class": "col-md-3 col-4 border-right"
      },
    marko_attrs8 = {
        "class": "col-md-8 col-7 pl-6"
      },
    marko_attrs9 = {
        "class": "btn btn-outline-secondary btn-lg display-inline-block mt-2"
      },
    marko_attrs10 = {
        "class": "col-xl-3 col-lg-4 col-5 d-flex justify-content-center text-center"
      },
    marko_attrs11 = {
        "class": "col"
      },
    marko_attrs12 = {
        "class": "list-inline"
      },
    marko_node8 = marko_createElement("div", {
        "class": "w-100 text-center"
      }, "21", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-check font-large-4 white-text"
        }, null, null, 0),
    marko_attrs13 = {
        "class": "p-50 cursor-pointer"
      };

const fhandler = new FormHandler({ key: 'customization', autosave: true });

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "h-100",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        out.be("h5", marko_attrs2, "3", component);

        out.n(marko_node0, component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Now let do your branding!");
            }
          }, out, __component, "5");

        out.ee();

        out.n(marko_node1, component);

        Row_tag({
            class: "m-0 d-flex align-items-center",
            renderBody: function(out) {
              out.be("div", marko_attrs7, "8", component, null, 0, {
                  onclick: __component.d("click", "onSelectLogo", false)
                });

              Image_tag({
                  alt: "Image",
                  class: "img-fluid round",
                  src: state.form.logo || DefaultLogo
                }, out, __component, "9");

              out.ee();

              out.be("div", marko_attrs8, "10", component);

              out.be("button", marko_attrs9, "11", component, null, 0, {
                  onclick: __component.d("click", "onSelectLogo", false)
                });

              Locale_tag({
                  text: "Add a Logo"
                }, out, __component, "12");

              out.ee();

              out.ee();
            }
          }, out, __component, "7");

        out.n(marko_node2, component);

        out.n(marko_node3, component);

        out.n(marko_node4, component);

        out.be("p", marko_attrs3, "16", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Choose the theme color that matches your institution's branding the best");
            }
          }, out, __component, "17");

        out.ee();

        Row_tag({
            class: "m-0 d-flex align-items-center",
            renderBody: function(out) {
              out.e("div", marko_attrs10, "19", component, 1)
                .e("div", {
                    "class": marko_classValue("d-flex align-items-center round " + (state.form.theme && state.form.theme.color)),
                    style: "width:110px;height:110px;"
                  }, "20", component, 1, 1)
                  .n(marko_node8, component);

              out.be("div", marko_attrs11, "23", component);

              out.be("ul", marko_attrs12, "24", component);

              marko_forOf(state.Colors, function(color, index) {
                var $keyValue$0 = "@" + index,
                    $keyScope$0 = "[" + ($keyValue$0 + "]");

                out.e("li", marko_attrs13, $keyValue$0, component, 1, 0, {
                    onclick: __component.d("click", "onSelectColor", false, [
                        color
                      ])
                  })
                  .e("div", {
                      "class": marko_classValue(marko_classValue([
                        "rounded",
                        color
                      ])),
                      title: color.toCapitalCase(),
                      style: "width:20px;height:20px"
                    }, "25" + $keyScope$0, component, 0);
              });

              out.ee();

              out.ee();
            }
          }, out, __component, "18");

        out.ee();

        out.n(marko_node5, component);

        out.n(marko_node6, component);

        out.n(marko_node7, component);

        out.be("div", marko_attrs4, "29", component);

        out.be("button", marko_attrs5, "30", component, null, 0, {
            onclick: __component.d("click", "onPrev", false)
          });

        Locale_tag({
            text: "Back",
            class: "px-3"
          }, out, __component, "31");

        out.ee();

        out.be("button", marko_attrs6, "32", component, null, 0, {
            onclick: __component.d("click", "onNext", false)
          });

        Bx_tag({
            type: "right-arrow-alt",
            class: "font-large-1 float-right white-text"
          }, out, __component, "33");

        Locale_tag({
            text: "Continue"
          }, out, __component, "34");

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
